import { Card, Link } from "@heroui/react";

import { useTranslations } from "@/src/i18n/i18n";
import { ROUTES } from "@/src/routes/paths";

/**
 * Route inconnue.
 *
 * Déclarée **hors** de la garde d'authentification : afficher « page
 * introuvable » ne divulgue rien, et renvoyer un visiteur non connecté vers la
 * connexion pour une adresse qui n'existe pas serait trompeur.
 */
export function NotFoundPage() {
  const t = useTranslations("notFound");

  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <Card className="w-full max-w-sm">
        <Card.Header>
          <Card.Title>{t("title")}</Card.Title>
          <Card.Description>{t("description")}</Card.Description>
        </Card.Header>

        <Card.Content>
          {/* `Link` de HeroUI, pas de React Router : `AriaRouting` lui a donné
              le `navigate` du routeur, la navigation reste donc côté client. */}
          <Link href={ROUTES.dashboard}>{t("back")}</Link>
        </Card.Content>
      </Card>
    </main>
  );
}
